export default __webpack_public_path__ + "static/media/IMG_20180930_020214_999.485ee0a0.jpg";